import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { HeaderSection } from './HeaderSection';
import { formatFieldValue, formatAddress } from '../utils';
import type { WorkOrderViewModel } from '@api/enterprise/openapi/models';
import { InfoItem } from '@components/InfoItem';

type CustomerLocationProps = {
  workOrder: WorkOrderViewModel;
};

export const CustomerLocation: React.FC<CustomerLocationProps> = ({
  workOrder
}) => {
  const { t } = useTranslation('workOrders');

  const shipToAddress = formatAddress(
    workOrder.shipToAddress1,
    workOrder.shipToAddress2,
    workOrder.shipToCity,
    workOrder.shipToState,
    workOrder.shipToZip
  );

  const billToAddress = formatAddress(
    workOrder.billToAddress1,
    workOrder.billToAddress2,
    workOrder.billToCity,
    workOrder.billToState,
    workOrder.billToZip
  );

  return (
    <HeaderSection
      icon={<BusinessIcon sx={{ fontSize: 16, color: 'text.secondary' }} />}
      title={t('workOrder.customerLocation.title')}
    >
      <InfoItem
        label={t('workOrder.customerLocation.customer')}
        value={formatFieldValue(workOrder.customerName)}
      />
      <InfoItem
        label={t('workOrder.customerLocation.branch')}
        value={formatFieldValue(workOrder.branchName)}
      />
      <InfoItem
        label={t('workOrder.customerLocation.shipTo')}
        value={
          shipToAddress !== '—' ? (
            <Tooltip title={shipToAddress}>
              <span
                style={{
                  display: 'block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {shipToAddress}
              </span>
            </Tooltip>
          ) : (
            shipToAddress
          )
        }
      />
      <InfoItem
        label={t('workOrder.customerLocation.billTo')}
        value={
          billToAddress !== '—' ? (
            <Tooltip title={billToAddress}>
              <span
                style={{
                  display: 'block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {billToAddress}
              </span>
            </Tooltip>
          ) : (
            billToAddress
          )
        }
      />
    </HeaderSection>
  );
};
